import { ClockIcon } from '@heroicons/react/24/outline';

import { useElapsedTime } from '../../../hooks/useElapsedTime';
import Text from '../../components/Text';
import { t } from '../../i18n/langue';

/**
 * Le chrono du ménage en cours — même hook que le web (`hooks/useElapsedTime`),
 * rafraîchi chaque seconde. `role="timer"` : un lecteur d'écran ne l'annonce pas
 * à chaque tic, il le lit quand on s'y arrête.
 */
export default function Chrono({ debut }: { debut: string }) {
    const { display } = useElapsedTime(debut);

    return (
        <div className="flex items-center gap-2">
            <ClockIcon aria-hidden="true" className="h-5 w-5 text-main-color" />
            <Text variante="petit" ton="attenue" as="span">
                {t('menage.chrono.enCoursDepuis')}
            </Text>
            <span role="timer">
                <Text variante="sousTitre" ton="marque" as="span" className="tabular-nums">
                    {display}
                </Text>
            </span>
        </div>
    );
}
